export const flightIndex: any = {
  sortBy: "並び替え",
  filterBy: "絞り込み",
  baggageWithItinerary: "経路{{index}}：{{baggageText}}",
  baggageAlertTitle: "預け入れ手荷物をご確認ください",
  baggageAlertDescription:
    "預け入れ手荷物を追加したフライトとの差額料金を表示しておりますので、無料の預け入れ手荷物がないフライトの場合、追加すると料金は高くなります。",
  detailModalTitle: "フライト詳細",
};
